import { REACT_APP_API_URL } from '../../setup/config';
import axios, { handleApiError } from '../axios';

export const getCompanyTypesData = async () => {
    try {
        let data = {}
        const response = await axios.post(`${REACT_APP_API_URL}/company-types/`, data);
        return await response.data;
    } catch (error) {
        console.log("getCompanyTypes - error", error)
        return handleApiError(error)
    }
}

export const getCompanyTypeDataById = async (companyTypeId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/company-types/${companyTypeId}`);
        return await response.data;
    } catch (error) {
        console.log("getCompanyTypeById - error", error)
        return handleApiError(error)
    }
}

export const addCompanyTypeData = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/company-types/create`, data)
        return await response.data;
    } catch (error) {
        console.log("addCompanyType - error", error)
        return handleApiError(error)
    }
}